import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import MlmorderDashboard from 'components/mlmorder/MlmorderDashboard';
import { getListAPI as getMlmorderList } from 'components/mlmorder/MlmorderAPI';
import { setMlmorderList, setMlmorderDashboardMlmorderList } from 'store/slice/DmpSlice';
import {getMlmorderInfoByMemberidAPI} from 'components/mlmorder/MlmorderAPI';

import { openDrawer } from './../../../store/slice/MenuSlice';
import { userprofileInfo } from 'store/slice/HeaderSlice';

export default function MlmorderPageImpl() {
    const dispatch = useDispatch();
    //const { mlmorderList} = useSelector((state)=>state.dmpslice);
    const {userprofileInfo} = useSelector((state)=>state.headerslice);

    useEffect(() => {
       // dispatch(openDrawer(false));
        getMlmorderInfoByMemberidAPI(userprofileInfo.userid, ()=>{}, getMlmorderListSuccess);
    },[]);
    
    const getMlmorderListSuccess = (list) =>{ dispatch(setMlmorderList(list));
    }
    
    return (
        < MlmorderDashboard />
    )

}